import React from "react";
import "./TrainingCalendar.css";

export default function TrainingCalendar() {
  return (
    <div className="training-calendar-page">
      <h1>Trainings Calendar</h1>

      <iframe
        title="Trainings Calendar"
        src="https://outlook.office365.com/owa/calendar/6087e055f01347e38134432f4ec108fb@deltagroupinc.org/63eb4b01007548ef94e3713b5a15bee916988754640780952161/calendar.html"
        className="training-calendar-frame"
      />
    </div>
  );
}